// @flow
import { call, put, takeLatest, select } from 'redux-saga/effects';
import getClientModerationContent from './getClientModerationContentApi';
import {
  requestClientQueueContent,
  receiveClientQueueContent,
  receiveClientQueueError,
} from './channelContentQueueActions';
import { type ActionType } from 'redux-actions';
import { addItemTask } from 'ducks/coreDataSaga';
import { selectToken } from 'ducks/SagaUtils';

export function* requestModerateClientQueueContent(
  action: ActionType<typeof requestClientQueueContent>
): Generator<*, *, *> {
  const token = yield select(selectToken);

  const { clientId, channelName } = action.payload;
  try {
    const data: ContentBlob = yield call(
      getClientModerationContent,
      token,
      clientId,
      channelName
    );
    const ugc_id = yield call(addItemTask, {
      data,
      clientId,
    });

    yield put.resolve(receiveClientQueueContent({ ugc_id }));
  } catch (error) {
    yield put(receiveClientQueueError(error));
  }
}

export default function* clientQueueModerateSaga(): Generator<*, *, *> {
  yield takeLatest(
    requestClientQueueContent,
    requestModerateClientQueueContent
  );
}



// WEBPACK FOOTER //
// ./src/containers/channels/channelContentQueueSaga.js